export type FairsTranslations = {
  addCandidates: string;
  bulk: {
    addMore: string;
    cancel: string;
    close: string;
    description: string;
    emailsLabel: string;
    emailsPlaceholder: string;
    error: string;
    fairHint: string;
    fairLabel: string;
    fairPlaceholder: string;
    found: string;
    result: {
      added: string;
      alreadyAdded: string;
      invalid: string;
      title: string;
    };
    submit: string;
    title: string;
    tooMany: string;
  };
  edit: {
    cancel: string;
    emailLabel: string;
    error: string;
    fairLabel: string;
    save: string;
    success: string;
    title: string;
  };
  list: {
    addedBy: string;
    allTitle: string;
    columns: {
      added: string;
      candidate: string;
      fair: string;
      registered: string;
      score: string;
      status: string;
    };
    edit: string;
    empty: string;
    fairTitle: string;
    notRegistered: string;
    openProfile: string;
    profileError: string;
  };
  results: {
    allFairs: string;
    empty: string;
    funnel: {
      added: string;
      quizFinished: string;
      recommended: string;
      registered: string;
    };
    lastAdded: string;
    noName: string;
    recommendedShare: string;
    showCandidates: string;
    title: string;
  };
  subtitle: string;
  title: string;
};

export const fairsTranslations: FairsTranslations = {
  addCandidates: 'Dodaj kandydatów',
  bulk: {
    addMore: 'Dodaj kolejnych',
    cancel: 'Anuluj',
    close: 'Zamknij',
    description:
      'Wklej adresy e-mail zebrane na stoisku: każdy w osobnej linii albo rozdzielone przecinkiem lub średnikiem. Możesz wkleić całą kolumnę z Excela.',
    emailsLabel: 'Adresy e-mail',
    emailsPlaceholder: 'anna.nowak@student.pl\njan.kowalski@uczelnia.edu.pl',
    error: 'Nie udało się dodać kandydatów. Spróbuj ponownie.',
    fairHint: 'Kandydaci z tą samą nazwą targów tworzą jedną kartę wyników.',
    fairLabel: 'Nazwa targów',
    fairPlaceholder: 'np. Targi Pracy AGH, marzec 2027',
    found: 'Rozpoznane adresy: {{count}}',
    result: {
      added: 'Dodani: {{count}}',
      alreadyAdded: 'Byli już na liście: {{count}}',
      invalid: 'To nie są adresy e-mail: {{count}}',
      title: 'Gotowe',
    },
    submit: 'Dodaj do listy',
    title: 'Dodaj kandydatów z targów',
    tooMany: 'Naraz możesz dodać najwyżej {{max}} adresów.',
  },
  edit: {
    cancel: 'Anuluj',
    emailLabel: 'Adres e-mail',
    error: 'Nie udało się zapisać zmian.',
    fairLabel: 'Nazwa targów',
    save: 'Zapisz',
    success: 'Zapisano zmiany.',
    title: 'Edytuj kandydata z targów',
  },
  list: {
    addedBy: 'dodane przez {{name}}',
    allTitle: 'Wszyscy kandydaci z targów',
    columns: {
      added: 'Dodany do listy',
      candidate: 'Kandydat',
      fair: 'Targi',
      registered: 'Rejestracja',
      score: 'Wynik',
      status: 'Etap rekrutacji',
    },
    edit: 'Edytuj',
    empty: 'Na tej liście nie ma jeszcze kandydatów.',
    fairTitle: 'Kandydaci: {{fair}}',
    notRegistered: 'Bez rejestracji',
    openProfile: 'Otwórz profil kandydata',
    profileError: 'Nie udało się otworzyć profilu kandydata.',
  },
  results: {
    allFairs: 'Wszystkie targi',
    empty:
      'Nie ma jeszcze kandydatów z targów. Dodaj adresy e-mail zebrane na stoisku, a zobaczysz tu, ilu z nich dołączyło do rekrutacji i ilu poleciliśmy.',
    funnel: {
      added: 'Dodani z targów',
      quizFinished: 'Ukończyli quiz',
      recommended: 'Rekomendowani',
      registered: 'Zarejestrowani',
    },
    lastAdded: 'Ostatnio dodany {{date}}',
    noName: 'Bez nazwy targów',
    recommendedShare: 'rekomendowanych z targów',
    showCandidates: 'Pokaż kandydatów',
    title: 'Wyniki targów',
  },
  subtitle: 'Kandydaci poznani na targach i to, jak daleko doszli w rekrutacji',
  title: 'Targi pracy',
};
